import { getBasePath } from '../../../utils/miscellaneous-utils'
import type { BackgroundImages } from './styles'

const HOME_HERO_IMAGE_PATH = '/assets/images/hero/home-hero-desktop.jpg'
const HERO_IMAGE_PATH = '/assets/images/hero/home-hero-mobile.jpg'
const DEFAULT_REGION_IMAGE_PATH = '/assets/images/hero/default.jpg'

/** Background images for home page hero section - used for both CSS and preloading */
export const HOME_BACKGROUND_IMAGES: BackgroundImages = {
    smallMobile: getBasePath(`${HERO_IMAGE_PATH}?imwidth=320`),
    mobile: getBasePath(`${HERO_IMAGE_PATH}?imwidth=420`),
    tablet: getBasePath(`${HOME_HERO_IMAGE_PATH}?imwidth=760`),
    desktop: getBasePath(`${HOME_HERO_IMAGE_PATH}?imwidth=1024`),
    wideScreen: getBasePath(`${HOME_HERO_IMAGE_PATH}?imwidth=1200`),
}

/** Background images for region page hero section - used for both CSS and preloading */
export const DEFAULT_REGION_BACKGROUND_IMAGES: BackgroundImages = {
    smallMobile: getBasePath(`${DEFAULT_REGION_IMAGE_PATH}?imwidth=320`),
    mobile: getBasePath(`${DEFAULT_REGION_IMAGE_PATH}?imwidth=420`),
    tablet: getBasePath(`${DEFAULT_REGION_IMAGE_PATH}?imwidth=760`),
    desktop: getBasePath(`${DEFAULT_REGION_IMAGE_PATH}?imwidth=1024`),
    wideScreen: getBasePath(`${DEFAULT_REGION_IMAGE_PATH}?imwidth=1200`),
}
